import * as React from 'react';

import type { FilterOption } from '@/components/customTable/types';

import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import { Box } from '@mui/material';
import { CaretDown } from '@phosphor-icons/react';
import { useState } from 'react';

export function FilterSelect({
  label,
  showInputLabel,
  fixInputLabel = true,
  errorText,
  value,
  required,
  placeholder,
  onChange,
  disabled,
  options,
  disabledOptions,
}: {
  label: string;
  hideTextLabel?: boolean;
  showInputLabel?: boolean;
  fixInputLabel?: boolean;
  errorText?: string;
  value: FilterOption | null;
  required?: boolean;
  placeholder: string;
  onChange: (value: FilterOption | string) => void;
  disabled?: boolean;
  options: any[];
  disabledOptions?: string[];
}) {
  const [search, setSearch] = useState('');
  const selectedOption = value ? options.find((option) => String(option.value) === String(value.value)) : null;

  const filteredOptions = options.filter((option) => option.label.toLowerCase().includes(search.toLowerCase()));

  return (
    <FormControl fullWidth key={label}>
      <Autocomplete
        options={filteredOptions}
        getOptionLabel={(option) => option.label}
        getOptionDisabled={(option) => disabledOptions?.includes(option.value) || false}
        isOptionEqualToValue={(option, optionValue) =>
          optionValue ? String(option.value) === String(optionValue.value) : false
        }
        value={selectedOption || null}
        onChange={(event, value) => onChange(value || '')}
        onInputChange={(event, value) => setSearch(value)}
        popupIcon={<CaretDown size={18} />}   
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            error={!!errorText}
            required={required}
            slotProps={
              fixInputLabel
                ? {
                    inputLabel: {
                      shrink: true,
                    },
                  }
                : {}
            }
            label={showInputLabel ? label : ''}
            // InputProps={{
            //   ...params.InputProps,
            //   endAdornment: (
            //     <>
            //       {loading ? <CircularProgress color="inherit" size={20} /> : null}
            //       {params.InputProps.endAdornment}
            //     </>
            //   ),
            // }}
          />
        )}
        slotProps={{
          chip: { color: "primary", size: "small" },
          paper: {
            sx: {
              fontSize: "16px !important",
            },
          },
        }}
        renderOption={(props, option, state) => {
          const isLast = state.index === filteredOptions.length - 1;

          return (
            <Box
              component="li"
              {...props}
              key={option.value}
              sx={{
                mb: 0.5,
                '&:hover': {
                  backgroundColor: 'action.hover',
                },
                ...(isLast && { flexDirection: 'column', alignItems: 'flex-start !important', mb: 0 }),
              }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" height="100%" flex={1}>
                <span style={{ flexGrow: 1, flexShrink: 1, minWidth: '60%' }}>{option.label}</span>
              </Box>
            </Box>
          );
        }}
      />
    </FormControl>
  );
}
